<template>
  <ul class="colorset-mini-view">
    <li class="col" v-for="(item, index) in colorset.array" :key="index" :style="{
      backgroundColor:itemCssColor(item),
      width: itemCssWidth(index)
    }"></li>
  </ul>
</template>

<style scoped>
ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  height: 100%;
}
.col {
  display: inline-block;
}
</style>

<script>
import Colorset from '@/models/Colorset'

export default {
  name: 'ColorsetMiniView',
  props: {
    colorset: Colorset
  },
  computed: {
  },
  methods: {
    itemCssColor (colorItem) {
      const rgb = colorItem.c
      return '#' + rgb.map(v => Math.floor(v).toString(16).padStart(2, '0')).join('')
    },
    itemCssWidth (index) {
      if (!this.$props.colorset || !this.$props.colorset.length) { return 0 }
      return this.$props.colorset.percentages[index] + '%'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ColorsetMiniView.vue